import { Component } from '@angular/core';
import { SharedPortalViewService } from '../../shared-portal-view.service';

@Component({
  selector: 'app-btcpay-wallet-alert',
  templateUrl: './btcpay-wallet-alert.component.html',
  styleUrls: ['./btcpay-wallet-alert.component.css']
})
export class BtcpayWalletAlertComponent {
  constructor(public sharedPortalViewService : SharedPortalViewService) {

  }

}
